var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18.1999C20.1028 18.1999 21 17.3027 21 16.1999C21 15.0971 20.1028 14.1999 19 14.1999C17.8972 14.1999 17 15.0971 17 16.1999C17 17.3027 17.8972 18.1999 19 18.1999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2315 6.02988C17.2144 5.68715 17.4876 5.3999 17.8307 5.3999H20.1693C20.5124 5.3999 20.7856 5.68715 20.7685 6.02988L20.4285 12.8299C20.4125 13.1492 20.149 13.3999 19.8292 13.3999H18.1708C17.851 13.3999 17.5875 13.1492 17.5715 12.8299L17.2315 6.02988Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.3999H16.649L16.749 12.3999H7V18.3999H17.2692C17.7458 18.7756 18.3471 18.9999 19 18.9999C19.6529 18.9999 20.2542 18.7756 20.7308 18.3999H22V16.3999H23V14.3999H22V12.3999H21.251L21.351 10.3999H22.5C23.3284 10.3999 24 11.0715 24 11.8999V12.3999H24.25C24.6642 12.3999 25 12.7357 25 13.1499V17.6499C25 18.0641 24.6642 18.3999 24.25 18.3999H24V18.8999C24 19.7283 23.3284 20.3999 22.5 20.3999H6.5C5.67156 20.3999 5 19.7283 5 18.8999V11.8999C5 11.0715 5.67156 10.3999 6.5 10.3999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3999H8V17.3999H12V13.3999Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBattery);
export default __webpack_public_path__ + "static/media/low_battery.44fb79b0e4689ef64036ecacc57ec2d4.svg";
export { ForwardRef as ReactComponent };